<template>
  <v-card>
    <v-card-title :class="selClass">
      <v-icon class="mr-5">mdi-calendar-month</v-icon>
      <span class="timeline-date mr-10">{{ rec.created | dt-sec }}</span>
      <span class="idcs-word-break">{{ $t("card.command." + rec.command+(rec.command==1200?(rec.p1!=0)+".1":"")) }}</span>
      <v-spacer></v-spacer>
      <span class="tl-amount idcs-data-back" v-if="rec.p1">{{ rec.p1 | currency }}</span>
      <span class="tl-amount idcs-data-back" v-else-if="rec.p2">{{ rec.p2 | currency }}</span>
    </v-card-title>
    <v-card-text class="idcs-data-back">
      <v-layout row fluid class="pt-4">
        <v-flex xs12 sm12 md3 lg3 xl3 class="pl-3 text-capitalize">{{
          $t("field.terminal")
        }}</v-flex>
        <v-flex xs12 sm12 md9 lg9 xl9 class="subtitle-2 font-weight-medium">
          <v-icon small class="mr-2">fa-cash-register</v-icon>
          {{ rec.terminal }}
        </v-flex>
        <v-flex xs12 sm12 md3 lg3 xl3 class="pl-3 text-capitalize mt-2">{{
          $t("field.subcompany")
        }}</v-flex>
        <v-flex xs12 sm12 md9 lg9 xl9 class="subtitle-2 mt-2 font-weight-black">
          <v-icon small class="mr-2">fa-store</v-icon>
          {{ rec.subcompany }}
        </v-flex>
      </v-layout>
      <!--<div>{{JSON.stringify(rec)}}</div>!-->
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LogTimeLineCard1",
  props: {
    record: { type: Object, required: true }
  },
  computed: {
    rec() {
      return this.record;
    },
    selClass() {
      if (this.record.code != 0) return "idcs-t-error";
      if (this.record.code == 0 && this.record.command == 1200) {
        return this.record.p1 ? "idcs-t-sell" : "idcs-t-buy";
      }
      if (this.record.command == 1100) return "idcs-t-info";
      return "idcs-t-reversal";
    }
  }
};
</script>

<style scoped>
.timeline-date {
  font-size: medium;
}
.tl-amount {
  border-radius: 8px;
  font-size: x-large;
  padding-left: 8px;
  padding-right: 8px;
}
</style>
